import { createSlice } from "@reduxjs/toolkit";
import { fetchEstampPaymentData, getPaymentAndUserInfo } from "api/payment";

const initialState = {
  isPaymentInProgess: false,
  isErrorInPaymentInitiation: false,
  payment_details: {},
  fetchingPaymentDetails: false,
  pending_amount: 0,
  maxAmountExceeded: false,
  isEnteredAmountZero: false,
  maxAmountThatCanBePaidIsExceeded: false,
  isRemainingAmountZero: false,
  isMaximumAmount: false,
  paymentTransactionsFetching: false,
  isCreatingPayment: false,
  isOnlinePaymentInitiated: false,
  estamp_payments: []
};
export const paymentReducer = createSlice({
  name: "paymentReducer",
  initialState,
  reducers: {
    setIsPaymentInProgess: (state, action) => {
      state.isPaymentInProgess = action.payload;
    },
    resetIsPaymentInProgess: (state, action) => {
      state.isPaymentInProgess = false;
    },
    setIsPaymentInitiationError: (state, action) => {
      state.isErrorInPaymentInitiation = action.payload;
    },
    setMaxAmountExceeded: (state, action) => {
      state.maxAmountExceeded = action.payload;
    },
    setIsEnteredAmountZero: (state, action) => {
      state.isEnteredAmountZero = action.payload;
    },
    setMaxAmountThatCanBePaidIsExceeded: (state, action) => {
      state.maxAmountThatCanBePaidIsExceeded = action.payload;
    },
    setIsRemainingAmountZero: (state, action) => {
      state.isRemainingAmountZero = action.payload;
    },
    setIsMaximumAmount: (state, action) => {
      state.isMaximumAmount = action.payload;
    },
    setIsPaymentTransactionsFetching: (state, action) => {
      state.paymentTransactionsFetching = action.payload;
    },
    setIsCreatingPayment: (state, action) => {
      state.isCreatingPayment = action.payload;
    },
    setIsOnlinePaymentInitiated: (state, action) => {
      state.isOnlinePaymentInitiated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPaymentAndUserInfo.pending, (state) => {
      state.fetchingPaymentDetails = true;
    });
    builder.addCase(getPaymentAndUserInfo.fulfilled, (state, action) => {
      state.payment_details = action.payload;
      state.pending_amount = action.payload?.pending_amount;
      state.fetchingPaymentDetails = false;
    });
    builder.addCase(fetchEstampPaymentData.fulfilled, (state, action) => {
      state.estamp_payments = action.payload?.length ? action.payload : [];
    });
  },
});

export const {
  setIsPaymentInitiationError,
  resetIsPaymentInProgess,
  setIsPaymentInProgess,
  setMaxAmountExceeded,
  setIsEnteredAmountZero,
  setMaxAmountThatCanBePaidIsExceeded,
  setIsRemainingAmountZero,
  setIsMaximumAmount,
  setIsPaymentTransactionsFetching,
  setIsCreatingPayment,
  setIsOnlinePaymentInitiated,
} = paymentReducer.actions;
export default paymentReducer.reducer;
